<script lang="ts">
    import { createEventDispatcher, onDestroy } from "svelte";

    import Input from "../leafElement/Input.svelte";
    import QrScanner from "../leafElement/QrScanner.svelte";

    import Switch from "../leafElement/Switch.svelte";
    import {
        displayFormatSensorId,
        genLabelFromMesurment,
    } from "../script/common";
    import type { MesurmentStaticOut } from "../script/requestTypes";
    import { Pinter } from "../script/store";
    import type { CustomerEnt, MesurmentFull } from "../script/types";
    import {
        pushNewOrder,
        pushOrderValidation,
        registerNewSensorConectionLisener,
    } from "../script/din/dataBroker";

    const WARN_DISPLAY_TIME = 10_000;
    const dispatch = createEventDispatcher();

    /* export let usedOwner: CustomerEnt = null;
    export let usedContractor: CustomerEnt = null; */
    export let disabledUserInteract = false;
    export let mesurmentGenerator: (probeId: string) => MesurmentStaticOut;

    /* let clientInfoLoaded = false;
    $: clientInfoLoaded = Boolean(usedOwner && usedContractor); */

    /* let disabled = false;
    $: disabled = Boolean(
        !usedOwner || !usedContractor || disabledUserInteract
    ); */
    let dbComunicationFailed = false;

    let newSensorMode = 0;
    let wizardStep = 0;
    $: if (wizardStep < 0 || wizardStep > 3) wizardStep = 0;

    let inputProbeId = "";
    let activeOrder: MesurmentFull | null;
    let usedNewMesurmentId: string;

    let usedPrinter = null;
    const printerSubscription = Pinter.subscribe((device) => {
        if (device) {
            usedPrinter = device;
        } else {
            device = null;
        }
    });
    let lastPulledProbe: {
        sensorID: string;
    } = null;
    let lastPulledProbe_displayedId;
    $: lastPulledProbe_displayedId = lastPulledProbe
        ? displayFormatSensorId(lastPulledProbe.sensorID)
        : "";

    const socketSubscription = registerNewSensorConectionLisener((data) => {
        if (data) {
            if (lastPulledProbe && wizardStep > 1) {
                console.warn("New sensor incomming, old one not finished!");
                return;
            }
            lastPulledProbe = data;
        }
    });

    let dbComunicationFailedInterval;
    async function registerSensor(probeId: string): Promise<MesurmentFull> {
        const rawOut = mesurmentGenerator(probeId);
        console.log(rawOut);
        const mesurment = await pushNewOrder(rawOut);

        if (!mesurment) {
            dbComunicationFailed = true;
            if (dbComunicationFailedInterval)
                clearTimeout(dbComunicationFailedInterval);
            dbComunicationFailedInterval = setTimeout(() => {
                dbComunicationFailedInterval = false;
            }, WARN_DISPLAY_TIME);
            return null;
        }
        activeOrder = mesurment;
        usedNewMesurmentId = mesurment.static.probe.id;
        return mesurment;
    }

    function resetAll() {
        inputProbeId = "";
        // lastPulledProbe_displayedId = "";
        lastPulledProbe = null;
        activeOrder = null;
        wizardStep = 0;
        qrCodeMatch = false;
    }
    function exportData(order: MesurmentFull) {
        pushOrderValidation(order);
        dispatch("newProbe", {
            data: order,
        });
    }

    function printSensor(mes: MesurmentFull) {
        if (!usedPrinter) {
            console.log("Tiskarna nepripojena");
        }
        const label = genLabelFromMesurment(mes);
        usedPrinter.send(label);
    }

    async function userManualaddSensor() {
        const newSensor = await registerSensor(inputProbeId);
        if (!newSensor) {
            return;
        }
        printSensor(newSensor);
        exportData(newSensor);
        resetAll();
    }

    async function userAddSenosor() {
        const newSensor = await registerSensor(lastPulledProbe.sensorID); // DANGER
        if (!newSensor) {
            return;
        }
        wizardStep = wizardStep + 1; // do not use short form
    }
    function printLoadedSensor() {
        printSensor(activeOrder);
        wizardStep = wizardStep + 1; // do not use short form
    }
    function finishAdingNewSensor() {
        // newSenor_sequenceNumber++;
        exportData(activeOrder);
        resetAll();
    }

    function wizardStepBack() {
        qrCodeMatch = false;
        wizardStep = wizardStep - 1; // do not use short form
    }

    let qrCodeMatch = false;
    let qrScannerWarn;

    function testMatchingProbeId(param) {
        const dVal = param.detail;
        if (activeOrder.static.id === dVal) {
            qrCodeMatch = true;
        } else if (qrScannerWarn) {
            qrScannerWarn();
        }
    }

    function destructor() {
        printerSubscription();
        socketSubscription();
        clearTimeout(dbComunicationFailedInterval);
    }
    onDestroy(destructor);
</script>

<div class="borderBox">
    <div class="formDivider formDivider_smallMargin">
        <p>Nový senzor</p>
    </div>
    <div style="margin-left: 1rem; display: flex;">
        <Switch
            bind:val={newSensorMode}
            disabled={false}
            iconA={"settings_input_antenna"}
            iconB={"edit"}
        />
        {#if dbComunicationFailed}
            <div class="standartdMesageCentered" style="margin-left: 25px;">
                <div class="standartFilledMesage errorColors">
                    <span class="material-icons"> report </span>
                    <span>Vyplňte nejdříve obecné informace</span>
                </div>
            </div>
        {/if}
    </div>
    {#if newSensorMode === 0}
        {#if wizardStep === 0}
            <div class="wizardTitle borderBox">
                <div class="wizardStep">
                    <span>{wizardStep + 1}.</span>
                </div>
                <p class="wizardManualText">
                    Odstraňte <strong>původní štítek</strong> ze senzoru (pokud je
                    nalepen)
                </p>
            </div>

            <div style="display: flex;">
                <button
                    class="standartButton standartButton_SMargin"
                    on:click={() => wizardStep++}
                    >Odstraněno - Pokračovat</button
                >
            </div>
        {:else if wizardStep === 1}
            <div class="wizardTitle borderBox">
                <div class="wizardStep">
                    <span>{wizardStep + 1}.</span>
                </div>
                <p class="wizardSensorId">
                    <span class="wizardSensorIdTitle">Senzor ID:</span>
                    <span class="wizardSensorIdValue"
                        >{lastPulledProbe_displayedId
                            ? lastPulledProbe_displayedId
                            : "— —"}</span
                    >
                </p>
                <p class="wizardManualText">
                    Připojte sondu k <strong>vyčítacímu zařízení</strong>
                    a
                    <strong>zmáčkněte tlačítko</strong>
                </p>
            </div>

            <div style="display: flex;">
                <button
                    class="standartButton standartButton_SMargin"
                    on:click={wizardStepBack}>Zpět</button
                >
                <button
                    disabled={!lastPulledProbe}
                    class="standartButton standartButton_SMargin"
                    on:click={userAddSenosor}>Potvrdit sensor</button
                >
            </div>
        {:else if wizardStep === 2}
            <div class="wizardTitle borderBox">
                <div class="wizardStep">
                    <span>{wizardStep + 1}.</span>
                </div>
                <p class="wizardSensorId">
                    <span class="wizardSensorIdTitle">Senzor ID:</span>
                    <span class="wizardSensorIdValue"
                        >{lastPulledProbe_displayedId
                            ? lastPulledProbe_displayedId
                            : "— —"}</span
                    >
                </p>
                <!--  <p class="wizardManualText">
                    Připojte tiskárnu (<a>v nastavení</a>) a
                    <strong>vytiskněte štítek</strong>
                </p> -->
                <p class="wizardManualText">
                    Připojte tiskárnu (v nastavení) a
                    <strong>vytiskněte štítek</strong>
                </p>
            </div>

            <div style="display: flex;">
                <button
                    class="standartButton standartButton_SMargin"
                    on:click={wizardStepBack}>Zpět</button
                >
                <button
                    disabled={!usedPrinter || !lastPulledProbe}
                    class="standartButton standartButton_SMargin"
                    on:click={printLoadedSensor}>Tisknout štítek</button
                >
                {#if !usedPrinter}
                    <div class="standartdMesageCentered">
                        <div class="standartFilledMesage errorColors">
                            <span class="material-icons"> report </span>
                            <span>Tiskárna nepřipojena</span>
                        </div>
                    </div>
                {/if}
            </div>
        {:else if wizardStep === 3}
            <div class="wizardTitle borderBox">
                <div class="wizardStep">
                    <span>{wizardStep + 1}.</span>
                </div>
                <p class="wizardSensorId">
                    <span class="wizardSensorIdTitle">Sensor ID:</span>
                    <span class="wizardSensorIdValue"
                        >{lastPulledProbe_displayedId
                            ? lastPulledProbe_displayedId
                            : "— —"}</span
                    >
                </p>
                <p class="wizardManualText">
                    Nalepte štítek na zařízení a zkontrolujte ho pomocí čtečky.
                </p>
            </div>
            {#if !qrCodeMatch}
                <div class="standartButton_SMargin">
                    <QrScanner
                        bind:showError={qrScannerWarn}
                        on:code={testMatchingProbeId}
                        autoFocus={true}
                    />
                </div>
            {/if}

            <div style="display: flex;">
                <button
                    class="standartButton standartButton_SMargin"
                    on:click={() => {
                        qrCodeMatch = false;
                        wizardStepBack();
                    }}>Zpět</button
                >
                <button
                    disabled={!qrCodeMatch}
                    class="standartButton standartButton_SMargin"
                    on:click={finishAdingNewSensor}>Uložit sensor</button
                >
               <!--  <button
                    class="standartButton standartButton_SMargin"
                    on:click={finishAdingNewSensor}>DEV skip</button
                > -->
            </div>
        {/if}
    {:else}
        <Input bind:val={inputProbeId} name={"ID"} required={true} />
        <div style="display: flex; margin-top: .7rem;">
            <button
                disabled={!inputProbeId || !usedPrinter}
                class="standartButton standartButton_SMargin"
                on:click={userManualaddSensor}>Uložit senzor</button
            >
            <!-- <button
                disabled={!usedPrinter || !inputProbeId}
                class="standartButton standartButton_SMargin"
                on:click={() => {
                    printSensor();
                }}>Tisknout senzor</button
            > -->
            {#if !usedPrinter}
                <div class="standartdMesageCentered">
                    <div class="standartFilledMesage errorColors">
                        <span class="material-icons"> report </span>
                        <span>Tiskárna nepřipojena</span>
                    </div>
                </div>
            {/if}
        </div>
    {/if}
</div>

<style>
    .wizardTitle {
        padding: 1rem;
        width: fit-content;
        display: grid;
    }
    .wizardTitle > .wizardStep {
        grid-row: 1 / span 2;
        grid-column: 1;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 2rem;
        font-weight: 500;
        padding: 0.5rem 1.3rem;
    }
    .wizardSensorId {
        font-size: 1.3rem;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        margin-bottom: 5px;
        padding: 7px;
        /* background: var(--back_D1); */
        width: fit-content;
        min-width: 20em;
        grid-row: 1;
        grid-column: 2;
    }
    .wizardSensorIdTitle {
        font-size: 0.9rem;
        color: var(--back_D2);
    }
    .wizardSensorIdValue {
        margin-left: 5px;
    }
    .wizardManualText {
        font-size: 0.9rem;
        font-weight: 300;
        margin-left: 5px;
        padding-left: 10px;
        border-left: var(--prim_L2) 2px solid;
        grid-row: 2;
        grid-column: 2;
    }
</style>
